import { getOneTimePrice } from '../container/DeviceDetail/helpers/promoPriceHelper';
import mountOptionPicker from './mountOptionPicker';
import {
    IOptionPickerCapacityItem,
    OPTION_PICKER_TYPE_CAPACITY,
} from '@vfde-brix/option-picker';
import { Price } from '@vfde-brix/core';
import { CAPACITY_KEY } from '../container/Options/constants';

/**
 * Mount the color picker
 *
 * @param container
 * @param capacities
 * @param currentCapacity
 * @param availableCapacities
 * @param isHardwareOnly
 * @param onChangeAction
 */
export const mountCapacityOptionPicker = (container, { capacities, currentCapacity, availableCapacities = [], isHardwareOnly }, onChangeAction?: (value: number) => void) => {
    const availableSizes = availableCapacities.map(capacity => capacity[CAPACITY_KEY]);
    const items: IOptionPickerCapacityItem[] = [];

    for (const [index, capacity] of capacities.entries()) {
        let state;

        switch (true) {
            case (!availableSizes.includes(capacity[CAPACITY_KEY])):
                state = 'disabled';
                break;
            case (currentCapacity === capacity[CAPACITY_KEY] || index === 0):
                state = 'checked';
                break;
        }

        items.push({
            stdValue: capacity[CAPACITY_KEY],
            stdCapacity: `${capacity.size}`,
            price: getItemPrice(availableCapacities, capacity, isHardwareOnly),
            optState: state,
        });
    }

    const onChange = (event: Event) => {
        const target = event.target as HTMLInputElement;
        onChangeAction(Number(target.value));
    };

    return mountOptionPicker(container, 'capacity-picker', OPTION_PICKER_TYPE_CAPACITY, items, onChange);
};

/**
 * Get item price
 *
 * @param availableCapacities
 * @param capacity
 * @param isHardwareOnly
 */
const getItemPrice = (availableCapacities, capacity, isHardwareOnly) => {
    // Capacity picker should show correct prices with or without addon.
    // If capacity is not available for one color, we read price from root capacities object
    const [availableCapacity] = availableCapacities.filter(filteredCapacity => filteredCapacity[CAPACITY_KEY] === capacity[CAPACITY_KEY]);
    const priceFromCapacity = availableCapacity ? availableCapacity : capacity;

    return Price.fromNumber(getOneTimePrice(priceFromCapacity, isHardwareOnly));
};
